import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const FAQs = () => {
    return (
        <div>
            <Typography sx={{ fontWeight: 600, fontSize: '20px', marginBottom: '20px' }}>
                FAQs
            </Typography>
            {/* First Accordion */}

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 600, fontSize: '20px' }}>
                        What is HawkClient?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails >
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography>
                            HawkClient is an offline-only API testing tool designed for developers to test, debug, and collaborate on API requests without requiring an internet connection.
                        </Typography>
                    </Box>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 600, fontSize: '20px' }}>
                        How does team collaboration work with HawkClient?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails >
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography>
                            Team collaboration with <strong>HawkClient</strong> is done through <strong>GitHub</strong>.  Users can share collections and changes via version control, enabling smooth collaboration.
                        </Typography>
                    </Box>
                </AccordionDetails>
            </Accordion>

            {/* Second Accordion */}
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 600, fontSize: '20px' }}>Privacy and Security</Typography>
                </AccordionSummary>
                <AccordionDetails >
                    <Typography>
                        <strong>HawkClient</strong> is an <strong>offline-only app</strong>.  It does <strong>not collect any user data</strong> nor require any <strong>sign-in</strong>, ensuring maximum privacy and security.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 600, fontSize: '20px' }}>
                        Does HawkClient require an account or login?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails >
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography>
                            No, HawkClient is completely offline and does not require any login or cloud-based accounts.
                        </Typography>
                    </Box>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 600, fontSize: '20px' }}>
                        Does HawkClient support GraphQL APIs?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails >
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography>
                            Yes, HawkClient fully supports REST and GraphQL API requests.
                        </Typography>
                    </Box>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 600, fontSize: '20px' }}>
                        Does HawkClient support gRPC?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails >
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography>
                            Yes, HawkClient supports gRPC requests.
                        </Typography>
                    </Box>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 600, fontSize: '20px' }}>
                        Does HawkClient support websocket?
                    </Typography>
                </AccordionSummary>
                <AccordionDetails >
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography>
                            Yes, HawkClient supports websocket requests.
                        </Typography>
                    </Box>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default FAQs;
